<template>
  <div class="home">
    <div class="connect">
      <div class="title">
        <span class="liquidate">Liquify</span> Your ETH 2.0 Staking
      </div>
      <div class="desc">
        Stake via StaFi Staking Contract and get <span class="reth">rETH</span> in return.
      </div>
      <div class="metamask" @click="$emit('connectMetamask')">
        <div class="icon">
          <img src="../assets/metamask.png" />
        </div>
        <div class="text">
          {{$t("home.connect-metamask")}}
        </div>
      </div>
      <div class="intro" @click="jumpToIntro">
        Get Intro
      </div>
    </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
import rpc from '../util/rpc.js';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';

export default {
  name: 'home',
  data() {
    return {
      selectFaqIndex: 0,
      dropStatus: 0
    }
  },
  created() {
  },
  methods: {
    jumpToIntro() {
      window.open('https://docs.stafi.io/rproduct/reth-solution');
    }
  }
}
</script>

<style lang="scss">
@import "../mixin.scss";

.home {
  background-color: #2B3239;
  width: 683px;
  height: 535px;
  border-radius: 19px;

  .connect {
    .title {
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      margin-top: 148px;

      .liquidate {
        font-style: italic;
        color: #00F3AB;
      }
    }
    .desc {
      font-size: 14px;
      text-align: center;
      margin-top: 9px;
      margin-bottom: 61px;

      .reth {
        font-weight: bold;
      }
    }
    .metamask {
      cursor: pointer;
      padding: 0px 24px;
      margin: auto;
      display: flex;
      font-size: 18px;
      border: 1px solid #BFBFBF;
      width: 254px;
      border-radius: 3px;
      height: 51px;
      line-height: 51px;
      align-items: center;

      .icon {
        margin-right: 24px;
        width: 31px;
        height: 27px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text {
        height: 22px;
        line-height: 22px;
      }
    }

    .intro {
      cursor: pointer;
      font-size: 14px;
      text-align: center;
      margin-top: 102px;
    }
  }
}
</style>
